import axios from 'store/axios_sso';
export const refreshToken = () => {
  return axios.post('/refresh').then(res => {
    // console.log(res.data);
    return res.data;
  });
};
